<div class="row">
    <h3>Please let your audience know when you are avaiable?</h3>
    <mat-stepper linear #stepper>
        <mat-step>
            <div class="row">
                <div class="col-md-9 col-sm-12">
                    <div class="panel-body">
                        <full-calendar [options]="calendarOptions">
                        </full-calendar>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12 p-l-30">
                    <h5 *ngIf="this.selectedDates.length>0">Selected Dates</h5>
                    <ul class="list-group">
                        <li class="list-group-item" *ngFor="let dateObj of selectedDates; ">
                            <div class="d-flex justify-content-between">
                                <div>{{ dateObj.start | date }}</div>
                                <div>
                                    <button mat-icon-button color="primary" (click)="removeDate(dateObj)"
                                        aria-label="Remove data">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <button matStepperNext mat-raised-button color="primary">Next</button>
            </div>
        </mat-step>
        <mat-step>

            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <p>Between what times are you free each day you're avaiable?</p>
                    <ul class="list-inline">
                        <li class="list-inline-item">
                            <strong>Start </strong> time
                            <ngb-timepicker [(ngModel)]="startTime" [meridian]="true"></ngb-timepicker>
                        </li>
                        <li class="list-inline-item ">
                            <div class="spacer"></div>
                        </li>
                        <li class="list-inline-item">
                            <strong>End</strong> time
                            <ngb-timepicker [(ngModel)]="endTime" [meridian]="true"></ngb-timepicker>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <button mat-raised-button color="primary" matStepperPrevious>Back</button>&nbsp;&nbsp;
                <button mat-raised-button color="primary" matStepperNext (click)="saveDateTime()">Finish</button>
            </div>
        </mat-step>
    </mat-stepper>
</div>